<template>
  <b-tabs content-class="">
    <b-tab
      v-for="(option, index) in userSettingsTabsLis"
      :key="index"
      @click="goTo(option.to)"
      :title-item-class="'custom-tab-outer-li'"
      :active="option.currentTab == $route.name ? true : false"
    >
      <template #title>
        <span v-b-popover.hover.bottomright="`${option.itemName}`">
          <img :src="`${option.itemImagePath}`" class="icon-tab" />
          <span>{{ option.itemName }}</span>
        </span>
      </template>
    </b-tab>
  </b-tabs>
</template>

<script>
import imgMasterAdmins from "@/assets/images/masterAdmins.svg";
import imgEmployees from "@/assets/images/employees.svg";
import imgStudents from "@/assets/images/students.svg";
import imgEstablishmentsRole from "@/assets/images/establishment-role.svg";
import imgValidSetting from "@/assets/images/UserValidSettings.svg";
import imgLoginCode from "@/assets/images/UserLoginCodes.svg";

import { checkPrivilege } from "./../../utils/functions";
import { USER_TYPE } from "./../../utils/constantLists";

import {
  hasMasterAdmin,
  hasMasterAdminEstablishmentsRole,
  hasMasterAdminValidSetting,
  hasMasterAdminLoginCode,
  hasEmployee,
  hasEmployeeEstablishmentsRole,
  hasEmployeeValidSetting,
  hasEmployeeLoginCode,
  hasStudent,
  hasStudentEstablishmentsRole,
  hasStudentValidSetting,
  hasStudentLoginCode,
} from "./../../utils/privilegeHelper";

export default {
  name: "UserSettingsTabs",

  userTypeToken: {
    type: String,
    default: "",
  },
  data() {
    return {
      userTypeTokenData: this.userTypeToken || this.$route.meta.userTypeToken,
    };
  },
  computed: {
    userSettingsTabsLis() {
      let tabs = [];

      switch (this.userTypeTokenData) {
        case USER_TYPE.MasterAdmin:
          tabs = this.userSettingsTabsListMasterAdmin;
          break;
        case USER_TYPE.Employee:
          tabs = this.userSettingsTabsListEmployee;
          break;
        case USER_TYPE.Student:
          tabs = this.userSettingsTabsListStudent;
          break;
      }

      return tabs;
    },
    userSettingsTabsListMasterAdmin: function () {
      let tabs = [];
      if (checkPrivilege(hasMasterAdmin())) {
        tabs.push({
          to: {
            name: "MasterAdmin",
          },
          itemName: this.$t("masterAdmins.modelName"),
          itemImagePath: imgMasterAdmins,
          currentTab: "MasterAdmin",
        });
      }
      if (checkPrivilege(hasMasterAdminEstablishmentsRole())) {
        tabs.push({
          to: {
            name: "MasterAdminEstablishmentsRole",
          },
          itemName: this.$t("UserSettings.roles"),
          itemImagePath: imgEstablishmentsRole,
          currentTab: "MasterAdminEstablishmentsRole",
        });
      }
      if (checkPrivilege(hasMasterAdminValidSetting())) {
        tabs.push({
          to: {
            name: "MasterAdminValidSetting",
          },
          itemName: this.$t("UserSettings.validSetting"),
          itemImagePath: imgValidSetting,
          currentTab: "MasterAdminValidSetting",
        });
      }
      if (checkPrivilege(hasMasterAdminLoginCode())) {
        tabs.push({
          to: {
            name: "MasterAdminLoginCode",
          },
          itemName: this.$t("UserSettings.loginCode"),
          itemImagePath: imgLoginCode,
          currentTab: "MasterAdminLoginCode",
        });
      }

      return tabs;
    },
    userSettingsTabsListEmployee: function () {
      let tabs = [];
      if (checkPrivilege(hasEmployee())) {
        tabs.push({
          to: {
            name: "Employees",
          },
          itemName: this.$t("employees.modelName"),
          itemImagePath: imgEmployees,
          currentTab: "Employee",
        });
      }
      if (checkPrivilege(hasEmployeeEstablishmentsRole())) {
        tabs.push({
          to: {
            name: "EmployeeEstablishmentsRole",
          },
          itemName: this.$t("UserSettings.roles"),
          itemImagePath: imgEstablishmentsRole,
          currentTab: "EmployeeEstablishmentsRole",
        });
      }
      if (checkPrivilege(hasEmployeeValidSetting())) {
        tabs.push({
          to: {
            name: "EmployeeValidSetting",
          },
          itemName: this.$t("UserSettings.validSetting"),
          itemImagePath: imgValidSetting,
          currentTab: "EmployeeValidSetting",
        });
      }
      if (checkPrivilege(hasEmployeeLoginCode())) {
        tabs.push({
          to: {
            name: "EmployeeLoginCode",
          },
          itemName: this.$t("UserSettings.loginCode"),
          itemImagePath: imgLoginCode,
          currentTab: "EmployeeLoginCode",
        });
      }

      return tabs;
    },
    userSettingsTabsListStudent: function () {
      let tabs = [];
      if (checkPrivilege(hasStudent())) {
        tabs.push({
          to: {
            name: "Students",
          },
          itemName: this.$t("students.modelName"),
          itemImagePath: imgStudents,
          currentTab: "Student",
        });
      }
      if (checkPrivilege(hasStudentEstablishmentsRole())) {
        tabs.push({
          to: {
            name: "StudentEstablishmentsRole",
          },
          itemName: this.$t("UserSettings.roles"),
          itemImagePath: imgEstablishmentsRole,
          currentTab: "StudentEstablishmentsRole",
        });
      }
      if (checkPrivilege(hasStudentValidSetting())) {
        tabs.push({
          to: {
            name: "StudentValidSetting",
          },
          itemName: this.$t("UserSettings.validSetting"),
          itemImagePath: imgValidSetting,
          currentTab: "StudentValidSetting",
        });
      }
      if (checkPrivilege(hasStudentLoginCode())) {
        tabs.push({
          to: {
            name: "StudentLoginCode",
          },
          itemName: this.$t("UserSettings.loginCode"),
          itemImagePath: imgLoginCode,
          currentTab: "StudentLoginCode",
        });
      }

      return tabs;
    },
  },
  watch: {},
  methods: {
    goTo(path) {
      this.$router.push(path).catch(() => {});
    },
  },

  async created() {},
};
</script>
